const TYPES = {
  SET_SLIDE_SHOW: "SET_SLIDE_SHOW",
};


const setSlideShow = (val) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.SET_SLIDE_SHOW,
      payload: val,
    });
  }
}

const updateInvoiceList = (payload) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.UPDATE_INVOICE_LIST,
      payload: payload,
    });
  }
}

export default {
  setSlideShow,
  TYPES,
};
